import { TextField } from '@mui/material';
import { styled } from '@mui/system';

export const StyledSearch = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: '100%',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#cccccc'
    },
    '&:hover fieldset': {
      borderColor: '#2596be'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2596be'
    }
  },
  '& .MuiInputBase-input': {
    fontSize: '16px',
    color: '#333',
    padding: '12px 14px'
  }
}));

export const StyledStudentName = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  fontWeight: '500',
  '&:hover': {
    textDecoration: 'none',
    color: theme.palette.primary.dark
  }
}));


